import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {PageableApiResult} from "../models/pagable-api-result.model";
import {and, comparison, eq, ge, le} from "rsql-builder";
import {Transaccion} from "../models/transaccion.model";
import {TransaccionListFilter} from "../models/transaccion-list-filter.model";
import { EndosoRequest } from '../models/endoso-request.model';

@Injectable({
  providedIn: 'root'
})
export class TransaccionApiService {

  private baseUrl:string = environment.apiBaseUrl+"/core/portal/profile/transactions";

  constructor(
    private httpClient: HttpClient
  ) { }

  getTransaccionList(): Observable<Transaccion[]> {
      return this.httpClient.get<Transaccion[]>(this.baseUrl);
  }


  getTransaccion(id): Observable<Transaccion> {
    return this.httpClient.get<any>(this.baseUrl+`/${id}`);
  }

  createTransaccion(importe: any, userReceiverId: any) {
    let req = {
      userReceiverID:userReceiverId,
      importe:importe
    }
    return this.httpClient.post<any>(this.baseUrl+`/add`,req);
  }

  searchTransaccionList(filter: TransaccionListFilter): Observable<PageableApiResult<Transaccion>> {
    const comps = [];

    if(filter.dateFilter && filter.dateFilter.from) {
      comps.push(comparison("date", ge(filter.dateFilter.from)))
    }
    if(filter.dateFilter && filter.dateFilter.to) {
      comps.push(comparison("date", le(filter.dateFilter.to)))
    }
    if(filter.transactionType) {
      comps.push(comparison("transactionType.id", eq(filter.transactionType)))
    }
    if(filter.id) {
      comps.push(comparison("id", eq(filter.id)))
    }
    let params = null;
    if (comps.length > 0) {
      let q = and(...comps).toString();
      params = new HttpParams().set("rquery", q);
    }
    if (filter.sortByAmount) {
      params = params.append("rsort", "amount").append("rdirection",filter.sortByAmount);
    }
    if (filter.sortByDate) {
      params = params.append("rsort", "date").append("rdirection",filter.sortByDate);
    }
    return this.httpClient.get<PageableApiResult<Transaccion>>(
      this.baseUrl +
      `/${filter.page}/${filter.size}`,
      {params}
    );

  }

  uploadComprobanteEndoso(transaccionId: number, body: EndosoRequest): Observable<any> {
    return this.httpClient.put<any>(`${this.baseUrl}/${transaccionId}/endoso`, body);
  }
}